import { render, staticRenderFns } from "./ViewTela.vue?vue&type=template&id=51db21ba"
import script from "./ViewTela.vue?vue&type=script&lang=js"
export * from "./ViewTela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports